import React, { useEffect } from "react";
import styled from "styled-components";
import noop from "lodash";
import get from "lodash/get";
import media from "cssMix/index";
import { CSSTransition } from "react-transition-group";
// style
const StyledReactModal = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: auto;
  transition: 0.1s;
`;
export default ({
  isOpen = false,
  onModalClose = noop,
  children,
  confirmModal = false,
  modalContent = false,
  containerSize,
}) => {
  const stopPropa = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    const rootStyle = document.getElementById("root").style;
    rootStyle.overflow = isOpen ? "hidden" : "";
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <>
          <StyledReactModal confirmModal={confirmModal} />
          <CSSTransition in={modalContent} timeout={300} classNames="pop">
            <ModalWrapper
              containerSize={containerSize}
              isOpen={modalContent}
              confirmModal={confirmModal}
              onClick={stopPropa}
            >
              {modalContent && (
                <>
                  <Closebtn onClick={onModalClose} />
                  {children}
                </>
              )}
            </ModalWrapper>
          </CSSTransition>
        </>
      )}
    </>
  );
};

const ModalWrapper = styled.div`
  ${({ containerSize }) => get(containerSize, "pc")};
  position: fixed;
  box-sizing: border-box;
  overflow: visible;
  left: 50%;
  top: 55%;
  z-index: 20;
  transform: scale(1, 1) translate(-50%, -50%);
  opacity: 1;
  transform-origin: 0% 0%;

  &.pop-enter {
    transform: scale(0, 0) translate(-50%, -50%);
    opacity: 0;
  }
  &.pop-enter-active {
    transform: scale(1, 1) translate(-50%, -50%);
    opacity: 1;
    transition: 0.3s ease-out;
  }
  &.pop-exit {
    opacity: 1;
  }
  &.pop-exit-active {
    opacity: 0;
    transition: 0.1s ease-out;
  }

  ${media.mobile`
  ${({ containerSize }) => get(containerSize, "mobile")};

  `}
`;

const Closebtn = styled.div`
  position: absolute;
  background: url("images/closebtn.png");
  background-size: 100%;
  width: 40px;
  height: 40px;
  right: -65px;
  top: -65px;
  cursor: pointer;

  ${media.mobile`
  width:35px;
  height: 35px;
  right:0px;
  top:-60px;
  `}
`;
